/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { ItemTagFragment } from './ItemTagFragment'
export type LocationItemMenuFragment = {
  __typename: 'LocationItem'
  id: number
  status: Types.LocationItemStatus
  item: {
    __typename: 'Item'
    id: number
    name: string
    active: boolean
    description: string | null
    hasSpecialInstructions: boolean
    tags: Array<{
      __typename: 'ItemTag'
      id: string
      name: string
      imageSvgUrl: string | null
      highlighted: boolean
    }>
    upsellType: { __typename: 'UpsellType'; id: number; name: string }
    image: {
      __typename: 'ItemImage'
      small: string
      medium: string
      high: string
    }
    price: { __typename: 'Money'; cents: number; formatted: string }
  }
}

export const LocationItemMenuFragment = ({
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LocationItemMenuFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LocationItem' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'item' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ItemTagFragment' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'upsellType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'medium' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'high' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cents' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formatted' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasSpecialInstructions' }
                }
              ]
            }
          }
        ]
      }
    },
    ...ItemTagFragment.definitions
  ]
} as unknown) as DocumentNode
